<template>
  <a :href="url">
    <img class="director_faculdade_img" :src="imagem">
  </a>
</template>

<script>
export default {
  name: "PresidenteImage",
  props:["imagem","url"]
}
</script>

<style scoped>
/*107*/
.director_faculdade_img {
  width: 500px;
}

/*1083*/
@media (max-width : 1024px) {
  /*1288*/
  .director_faculdade_img {
    display: none;
  }
}
</style>